import { render, staticRenderFns } from "./cross-walk-table.vue?vue&type=template&id=54c897e8&scoped=true&"
import script from "./cross-walk-table.ts?vue&type=script&lang=ts&"
export * from "./cross-walk-table.ts?vue&type=script&lang=ts&"
import style0 from "./cross-walk-table.scss?vue&type=style&index=0&id=54c897e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c897e8",
  null
  
)

export default component.exports